export default __webpack_public_path__ + "static/media/screenshot_org_dashboard_desktop_purple.3cb93c54.png";